if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('click', this.handleGalleryClick.bind(this));
        this.addEventListener('keydown', this.handleGalleryKeydown.bind(this));
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const openerMediaId = this.openedBy?.getAttribute('data-media-id');
        const requestedMediaId = openerMediaId?.match(/(\d+)$/)?.[1] || openerMediaId;
        const firstPanel = this.querySelector('[data-media-panel]');
        this.activateMedia(requestedMediaId || firstPanel?.dataset.mediaPanel);
      }

      handleGalleryClick(event) {
        const thumbnail = event.target.closest('[data-media-target]');
        if (thumbnail) {
          this.activateMedia(thumbnail.dataset.mediaTarget);
          return;
        }

        if (event.target.closest('[data-media-previous]')) {
          this.stepMedia(-1);
          return;
        }

        if (event.target.closest('[data-media-next]')) this.stepMedia(1);
      }

      handleGalleryKeydown(event) {
        const thumbnail = event.target.closest('[data-media-target]');
        if (!thumbnail) return;

        const thumbnails = this.thumbnails;
        const currentIndex = thumbnails.indexOf(thumbnail);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = currentIndex + 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = currentIndex - 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = thumbnails.length - 1;
        if (nextIndex === currentIndex) return;

        event.preventDefault();
        nextIndex = (nextIndex + thumbnails.length) % thumbnails.length;
        thumbnails[nextIndex].focus();
        this.activateMedia(thumbnails[nextIndex].dataset.mediaTarget);
      }

      stepMedia(direction) {
        const panels = this.panels;
        if (panels.length < 2) return;

        const activeIndex = panels.findIndex((panel) => panel.classList.contains('active'));
        const nextIndex = (activeIndex + direction + panels.length) % panels.length;
        this.activateMedia(panels[nextIndex].dataset.mediaPanel);
      }

      activateMedia(mediaId) {
        if (!mediaId) return;

        const panels = this.panels;
        const activePanel = panels.find((panel) => panel.dataset.mediaPanel === String(mediaId)) || panels[0];
        if (!activePanel) return;

        window.pauseAllMedia();

        panels.forEach((panel) => {
          const isActive = panel === activePanel;
          panel.classList.toggle('active', isActive);
          panel.hidden = !isActive;
        });

        this.thumbnails.forEach((thumbnail) => {
          const isActive = thumbnail.dataset.mediaTarget === activePanel.dataset.mediaPanel;
          thumbnail.classList.toggle('is-active', isActive);
          thumbnail.setAttribute('aria-selected', String(isActive));
          thumbnail.tabIndex = isActive ? 0 : -1;
          if (isActive) {
            const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            thumbnail.scrollIntoView({
              behavior: prefersReducedMotion ? 'auto' : 'smooth',
              block: 'nearest',
              inline: 'nearest',
            });
          }
        });

        const currentPosition = activePanel.dataset.mediaPosition || '1';
        const counter = this.querySelector('[data-media-current]');
        if (counter) counter.textContent = String(currentPosition).padStart(2, '0');

        const deferredMedia = activePanel.querySelector('deferred-media');
        const activeMediaTemplate = deferredMedia?.querySelector('template');
        if (activeMediaTemplate?.content.querySelector('.js-youtube')) deferredMedia.loadContent();
      }

      get panels() {
        return Array.from(this.querySelectorAll('[data-media-panel]'));
      }

      get thumbnails() {
        return Array.from(this.querySelectorAll('[data-media-target]'));
      }
    }
  );
}
